export default __webpack_public_path__ + "static/media/loyalty-icon.053da308.svg";